import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表

//系统管理相关接口
const myAllWork={

//登录 卡号密码
  getPage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/guest/card/page`,params);
  },
  //绑卡
  bindCard(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/guest/card/bindCard`,params);
  },
  //绑科目
  bindSubject(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/guest/card/bindSubject`,params);
  },
  //读取科目树
  getSubTree(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/guest/card/getSubTree`,params);
  },
  //读取科目树
  getCardInfo(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/guest/card/getCardInfo/${params.cardid}`,null);
  },
}
// 导出接口
export  default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/myCards.js